// extracted by mini-css-extract-plugin
module.exports = {"popperWrapper":"F-base-popover-popper-wrapper-3Hdrc","show":"F-base-popover-show-2pjz9","unMounted":"F-base-popover-unMounted-3T5zf"};